var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"promo-icon-wrapper"},[_c('div',{staticClass:"promo-offer-indicator",style:(`color: ${_vm.color}`)},[_c('icon',{staticClass:"promo-offer-indicator__icon",attrs:{"name":_vm.offerIndicator.icon}})],1),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }